import { Employee } from "@pentacode/core";
import { LitElement, css, html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import "../../elements/new-employee-dialog";
import type { NewEmployeeDialog } from "../../elements/new-employee-dialog";
import { app } from "../../init";
import { singleton } from "../../lib/singleton";
import { type RouteArgs, Routing } from "../../mixins/routing";
import { StateMixin } from "../../mixins/state";
import { mixins, shared } from "../../styles";
import "./[id]";
import "./all";

@customElement("ptc-employees")
export class Employees extends Routing(StateMixin(LitElement)) {
    readonly routePattern = /^employees(?:\/(?<id>[^/]+))?/;

    @state()
    private _loading = false;

    @state()
    private _page: string;

    @singleton("ptc-new-employee-dialog")
    private _newEmployeeDialog: NewEmployeeDialog;

    handleRoute([id]: RouteArgs) {
        id = id as string;
        if (id === "all") {
            this._page = "all";
            return;
        }

        if (!app.getEmployee(parseInt(id))) {
            this.go(`employees/all`, undefined, true);
            return;
        }

        this._page = "employee";
    }

    private async _newEmployee() {
        const employee = await this._newEmployeeDialog.show(new Employee());
        if (employee) {
            this.go(`employees/${employee.id}`);
        }
    }

    static styles = [
        shared,
        css`
            ptc-employees-single,
            ptc-employees-all,
            ptc-employees-new {
                ${mixins.fullbleed()};
            }

            @media print {
                ptc-employees-single,
                ptc-employees-all,
                ptc-employees-new {
                    position: static;
                }
            }
        `,
    ];

    render() {
        return html`
            ${this._page === "all"
                ? html`<ptc-employees-all @newemployee=${this._newEmployee}
                      ><slot name="submenu" slot="submenu"></slot
                  ></ptc-employees-all>`
                : nothing}
            ${this._page === "employee"
                ? html`<ptc-employees-single @newemployee=${this._newEmployee}
                      ><slot name="submenu" slot="submenu"></slot
                  ></ptc-employees-single>`
                : nothing}

            <div class="fullbleed center-aligning center-justifying vertical layout scrim" ?hidden=${!this._loading}>
                <ptc-ui-spinner ?active=${this._loading}></ptc-ui-spinner>
            </div>
        `;
    }
}
